import { createContext, useContext } from 'react';

/** `top-level` limits clause descriptions to each condition group and the clauses directly inside it. */
export type SegmentDescriptionScope = 'all' | 'top-level';

interface SegmentViewerSettings {
  readOnly: boolean;
  descriptionScope: SegmentDescriptionScope;
}

export const SegmentViewerSettingsContext = createContext<SegmentViewerSettings>({
  readOnly: false,
  descriptionScope: 'all',
});

export const useSegmentReadOnly = () => useContext(SegmentViewerSettingsContext).readOnly;

/** Whether a clause shows its description and the add-description control. */
export const useClauseDescriptionVisible = (nested: boolean) =>
  useContext(SegmentViewerSettingsContext).descriptionScope === 'all' || !nested;
